export const debounce = (onChange: (value: string) => void) => {
    let timeout: NodeJS.Timeout;

    return (value: string) => {
        if (value.length > 2) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                onChange(value);
            }, 500);
        }

        if (value.length <= 2) {
            onChange("");
        }
    };
};
